// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2gFJh","buttons":"RemoveExpirationActionButtons_buttons__3QGJv"};